import React from 'react';
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  SelectOutlined,
  CopyOutlined,
} from '@ant-design/icons';
import { Typography, Tooltip } from 'antd';
import { useRouter } from 'next/router';
import { DEFAULT_SCENE_PREVIEW } from 'util/constants';
import styles from './scene-thumbnail.module.css';

const { Text } = Typography;

function SceneThumbnail({
  sceneData,
  setModalScene,
  setIsModalEditSceneOpen,
  setIsModalDeleteSceneOpen,
  isFromDrawer,
  onCloneScene,
}) {
  const router = useRouter();

  function redirectToEditor(sceneId) {
    if (isFromDrawer) {
      window.location.assign(`/user/studio/scene/${sceneId}`);
      return;
    }
    router.push(`/user/studio/scene/${sceneId}`);
  }

  function redirectToPublicScene(sceneId) {
    router.push(`/scene/${sceneId}`);
  }

  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        <img
          alt='scene thumbnail'
          className={styles.scenePreviewImage}
          src={
            sceneData.thumbnail?.replace(
              'https://assets2022.s3.amazonaws.com',
              'https://d23hwblhugcea5.cloudfront.net'
            ) || DEFAULT_SCENE_PREVIEW
          }
        />
        <div className={styles.overlay}>
          <div className={styles.buttons}>
            <Tooltip title='Preview scene'>
              <EyeOutlined
                className={styles.icon}
                onClick={() => {
                  redirectToPublicScene(sceneData.id);
                }}
              />
            </Tooltip>
            <Tooltip title='Edit scene' data-cy='edit-scene-icon'>
              <SelectOutlined
                className={styles.icon}
                onClick={() => {
                  redirectToEditor(sceneData.id);
                }}
              />
            </Tooltip>
            <Tooltip title='Clone scene'>
              <CopyOutlined
                className={styles.icon}
                onClick={() => {
                  onCloneScene(sceneData.id);
                }}
              />
            </Tooltip>
            <Tooltip title='Delete scene'>
              <DeleteOutlined
                className={styles.icon}
                data-cy='delete-scene-icon'
                onClick={() => {
                  setModalScene(sceneData);
                  setIsModalDeleteSceneOpen(true);
                }}
              />
            </Tooltip>
          </div>
        </div>
        <div className={styles.sceneNameContainer}>
          <div className={styles.sceneNameTopPart}>
            <Text className={styles.sceneName}>{sceneData.name}</Text>
            <Tooltip title='Edit scene info'>
              <EditOutlined
                className={styles.editInfoIcon}
                onClick={() => {
                  setModalScene(sceneData);
                  setIsModalEditSceneOpen(true);
                }}
              />
            </Tooltip>
          </div>
          <div className={styles.desc}>{sceneData.description}</div>
        </div>
      </div>
    </div>
  );
}

export default SceneThumbnail;
